export const adap_producto = ({producto, presentacion}) => {

    let obj = {
        id: producto.id,
        nombre: producto.nombre,
        coleccion: producto.coleccion,
        cantidad: 1,
        presentacion: presentacion.nombre,
        valor: producto.valor,
        img: presentacion.img ? presentacion.img : producto.img
    }

    console.log(obj)

    return obj

}